<template>
  <span class="block">
    <span>{{ $t("auth.label.already-an-account") }}</span>
    <NuxtLinkLocale
      to="/auth/login"
      class="ms-xs break-words font-medium text-blue underline hover:text-blue-700"
    >{{ $t("auth.action.sign-in") }}
    </NuxtLinkLocale>
  </span>
</template>
